module.exports = __webpack_public_path__ + "media/605ConferenceSpace.9a15e5fc.webm";